import axiosClient from "utils/axios";
import { ApiList, ApiOptionList, ApiResponse } from "../../../types/api.types";
import type {
  AddEmployeeRequest,
  Employee,
  UpdateEmployeeRequest,
} from "features/Employees/types/employee.types";
import {
  employeeRequestToApiFields,
  employeeRequestToFormData,
} from "features/Employees/utils/employeeFormPayload";

export { employeeRequestToFormData as employeeToFormData };
export { buildEmployeeRequestFromFormValues } from "features/Employees/utils/employeeFormPayload";

export const getEmployees = async ({
  page,
  limit,
  search,
}: {
  page?: number;
  limit?: number;
  search?: string;
} = {}) => {
  const { data } = await axiosClient.get<ApiResponse<ApiList<Employee[]>>>(
    "/employees",
    { params: { page, limit, search } },
  );
  return data;
};

export const getEmployeeOptions = async ({
  query,
  limit,
  page,
}: {
  query?: string;
  limit?: number;
  page?: number;
}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
      `/employees/options`,
      { params: { query, limit, page } },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching Employee Options : ", err);
    throw err;
  }
};

export const getEmployee = async (id: number) => {
  if (!Number.isInteger(id) || id <= 0) {
    throw new Error("Invalid employee ID");
  }
  const { data } = await axiosClient.get<ApiResponse<Employee>>(
    `/employees/${id}`,
  );
  return data;
};

export const createEmployee = async (
  payload: AddEmployeeRequest | FormData,
) => {
  const body =
    payload instanceof FormData ? payload : employeeRequestToApiFields(payload);
  const { data } = await axiosClient.post<ApiResponse<Employee>>(
    "/employees",
    body,
  );
  return data;
};

export const updateEmployee = async (
  id: number,
  payload: UpdateEmployeeRequest | FormData,
) => {
  const body =
    payload instanceof FormData ? payload : employeeRequestToApiFields(payload);
  const { data } = await axiosClient.put<ApiResponse<Employee>>(
    `/employees/${id}`,
    body,
  );
  return data;
};

export interface UpdateMyProfileRequest {
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  pincode?: string | null;
  bloodGroup?: string | null;
}

export const updateMyProfile = async (
  payload: UpdateMyProfileRequest | FormData,
) => {
  const { data } = await axiosClient.put<ApiResponse<Employee>>(
    "/employees/me/profile",
    payload,
  );
  return data;
};

export const updateEmployeeStatus = async (
  id: number,
  isPayrollable: boolean,
) => {
  const { data } = await axiosClient.patch<ApiResponse<Employee>>(
    `/employees/${id}/status`,
    { isPayrollable },
  );
  return data;
};
